import './PersonInfoCard.scss';
import React from 'react';
import Avatar from '../../../assets/icons/Avatar';


const PersonInfoCard = ({fullName, attributes}) => {
    return (
        <div className={'person-info-card-main-container'}>
            <div className={'person-info-card-container'}>
                <div className={'person-info-card-avatar-container'}>
                    <Avatar width={'20px'} height={'20px'} color={'primary-500'}/>
                </div>
                <div className={'person-info-card-information-container'}>
                    <p className={'subtitle-1 v2-c-text-title'}>{fullName}</p>
                    {attributes && attributes.map((attribute, index) => {
                        return (
                            <p className={'body-2 c-text-base'} key={index}>{attribute}</p>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
export default PersonInfoCard;
